<template>
  <transition name="mask">
    <div class="mask-wrapper" v-if="showMask" @click.self="hideModal">
      <transition name="fade">
        <div class="fade-modal-box" v-show="show" :style="{ background: _bg }">
          <div class="title-box" v-if="title">
            <h1
              class="title"
              :style="{ color: title_color || hexToRgba(gc.main_color, 0.6) }"
            >
              {{ title }}
            </h1>
            <p
              class="title-desc"
              :style="{ color: hexToRgba(gc.main_color, 0.4) }"
              v-if="desc"
            >
              {{ desc }}
            </p>
            <!-- <div class="bottom-line" :style="{'background-color': hexToRgba(gc.main_color, .2)}"></div> -->
          </div>
          <div class="btn-close" v-if="showCloseBtn" @click="hideModal">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12Z"
                fill="#B19B9F"
              />
            </svg>
          </div>
          <div class="content">
            <div class="scroll-wrapper">
              <slot></slot>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script type="text/ecmascript-6">
import { utils } from '_lib/utils'
export default {
  props: {
    is_two: { // 是否为二级弹窗，二级弹窗的话不移除body-fixed
      type: Boolean,
      default: false,
    },
    isFixedHeight: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: ''
    },
    title_color: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    bg: {
      type: String,
      default: ''
    },
    gc: {
      type: Object,
      default: () => {}
    },
    showCloseBtn: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    _bg () {
      const isImg = this.bg.indexOf('https') !== -1
      if (isImg) {
        return `url(${this.bg}) repeat-y top / 100%`
      }
      return this.bg
    }
  },
  data () {
    return {
      show: false,
      showMask: false
    }
  },
  methods: {
    hexToRgba: utils.hexToRgba,
    showModal () {
      console.log(this.gc);
      this.showMask = true
      this._top = document.scrollingElement.scrollTop
      document.body.classList.add('body-fixed')
      document.body.style.top = -this._top + 'px'
      this.$nextTick(() => {
        this.show = true
      })
    },
    hideModal () {
      this.show = false
      if (!this.is_two) {
        document.body.classList.remove('body-fixed')
      }
      this.$parent.is_two = false
      document.scrollingElement.scrollTop = this._top;
      setTimeout(() => {
        this.showMask = false
      }, 100)
    }
  }
}
</script>

<style lang="less">
.fade-modal-box {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  position: fixed;
  bottom: 0;
  left: 0;
  height: 79.68%;
  z-index: 5;
  padding-top: 16px;
  transform: translate3d(0, 0, 0);
  overflow: hidden;
  .content {
    width: calc(100% + 20px);
    height: 0;
    flex: 1;
    padding-right: 20px;
    position: relative;
    z-index: 2;
    overflow-y: scroll;
    .scroll-wrapper {
      width: 100%;
    }
  }
  .title-box {
    padding: 0 16px;
    position: relative;
    .title {
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 16px;
    }
    .title-desc {
      font-size: 13px;
      line-height: 20px;
      color: #ffffff;
      opacity: 0.8;
      margin-bottom: 8px;
    }
    .bottom-line {
      position: absolute;
      bottom: -12px;
      left: 0;
      width: 100%;
      height: 0.5px;
    }
  }
  .btn-close {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 12px;
    right: 12px;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.35s cubic-bezier(0.24, 0.01, 0.24, 1);
}
.fade-enter,
.fade-leave-to {
  transform: translateY(100%);
}
.fade-enter-to,
.fade-leave {
  transform: translateY(0);
}
.mask-wrapper {
  width: 100%;
  max-width: 480px;
  height: 100%;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 100;
}
.mask-enter-active,
.mask-leave-active {
  transition: all 0.35s cubic-bezier(0.24, 0.01, 0.24, 1);
}
.mask-enter,
.mask-leave-to {
  opacity: 0;
}
.mask-enter-to,
.mask-leave {
  opacity: 1;
}
</style>
